import React from "react";
import { FormSurveySvgIcon } from "../../common/CustomIcon";
import FormResponse from "../forms/FormResponse";
import OrderItemDetails from "./OrderItemDetails";

const OrderForm = ({ isFormFilled, currentOrder, location }) => {
  return (
    <OrderItemDetails
      isFilled={isFormFilled}
      currentOrder={currentOrder}
      location={location}
      type="Form"
      IconComponent={FormSurveySvgIcon}
      ResponseComponent={FormResponse}
    />
  );
};

export default OrderForm;
